import { render, staticRenderFns } from "./DialogCreateRelatorioComponent.vue?vue&type=template&id=cc755220&"
import script from "./DialogCreateRelatorioComponent.vue?vue&type=script&lang=js&"
export * from "./DialogCreateRelatorioComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports